import { render, staticRenderFns } from "./local-office-info.vue?vue&type=template&id=3a22ca4c&"
import script from "./local-office-info.vue?vue&type=script&lang=js&"
export * from "./local-office-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\MidwestBeltone.Iframes.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a22ca4c')) {
      api.createRecord('3a22ca4c', component.options)
    } else {
      api.reload('3a22ca4c', component.options)
    }
    module.hot.accept("./local-office-info.vue?vue&type=template&id=3a22ca4c&", function () {
      api.rerender('3a22ca4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/pages/local-office-info.vue"
export default component.exports